export const getDeleteDialogueBoxContentBasedOnSetType = ({ nodeType, t }) => {
  switch (nodeType) {
    case "CARD":
    case "CHECKLIST":
    case "NESTED_CHECKLIST": {
      return {
        modalTitle: t("common:delete_with_label", {
          label: t("common:list_item_other"),
        }),
        modalSubtext: t("scopeAndSequence:delete_list_items_subtext"),
        modalWarning: t("scopeAndSequence:delete_list_items_warning"),
      };
    }
  }
};
